import MyMaorSuccess from "./MyMaorSuccess";

export default MyMaorSuccess;
